import Heading from "../../../components/heading/heading.component";
import { LatestNewsContainer } from "./LatestNews.styles";


const LatestNews = () => {

  return (
    <LatestNewsContainer className="App login_page">
      <Heading previusPage={'Latest News'} />
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed fringilla elit imperdiet molestie efficitur. Curabitur eget ligula ac diam mattis
        iaculis in eu dui. Aliquam erat volutpat. Pellentesque hendrerit tempor libero. In lobortis lorem vel egestas mollis. Mauris gravida ultrices imperdiet.
        Phasellus euismod, erat eu tempor pellentesque, mi tortor congue nibh, et convallis elit nisl vel erat. Quisque metus ex, dignissim ut feugiat vitae,
        scelerisque at ante. Nulla pulvinar bibendum est, quis hendrerit est tristique quis. Aenean gravida volutpat dui, a ornare enim tincidunt et. Etiam sit amet sem dui.
        Maecenas auctor enim eu venenatis blandit. Donec efficitur feugiat dapibus.</p>
      <br />
      <p>  Proin scelerisque turpis ex, ac scelerisque sem porttitor in. Sed scelerisque leo sit amet felis fringilla rutrum. Phasellus egestas, turpis in congue semper, nisl
        odio vehicula arcu, vel euismod erat lacus vel ante. Maecenas convallis suscipit ipsum, id imperdiet leo ultricies vitae. Sed urna metus, cursus a magna eu, tempus
        interdum turpis. Mauris hendrerit tortor vel nisi sollicitudin, ut consequat est lobortis. Integer vulputate tincidunt nisl eget congue. Sed sed commodo felis. Ut
        blandit lacinia libero a rhoncus. Phasellus vel ante tincidunt, bibendum erat ut, euismod quam. Donec blandit quam ut dolor placerat porta. Vivamus eget auctor velit.</p>
      <br />
      <p>  Praesent lacinia ornare ultricies. Nam varius neque dui, ornare vulputate arcu posuere et. Nulla et ipsum urna. Praesent mattis ultrices egestas. Pellentesque
        facilisis eros quis nunc eleifend convallis. Pellentesque tincidunt et augue vel aliquet. Praesent condimentum rhoncus nunc sed vulputate.</p>
    </LatestNewsContainer>
  );
}

export default LatestNews;